import { Component } from '@angular/core';
import {BaseRecordTableItemComponent} from '../base-record-table-item/base-record-table-item.component';

@Component({
  selector: 'app-boolean-record-table-item',
  standalone: false,
  templateUrl: './boolean-record-table-item.component.html',
  styleUrl: './boolean-record-table-item.component.scss'
})
export class BooleanRecordTableItemComponent extends BaseRecordTableItemComponent{

}
